import { MapPinOff, LogIn, LogOut } from "lucide-react";
import { useFetch } from "@/lib/positions";
import { useLang } from "@/lib/i18n";
import { fmtDateTimeMtl } from "@/lib/time";

const fmtDist = (m, lang) => (m >= 1000 ? `${(m / 1000).toLocaleString(lang === "fr" ? "fr-CA" : "en-CA", { maximumFractionDigits: 1 })} km` : `${m} m`);

export const OffsiteAttempts = () => {
  const { t, lang } = useLang();
  const { data } = useFetch("/clock-attempts", { limit: 10 });
  return (
    <div className="mt-10" data-testid="offsite-attempts-panel">
      <div className="flex items-center gap-2 mb-4">
        <MapPinOff className="w-5 h-5 text-red-500" strokeWidth={1.5} />
        <h2 className="font-display text-2xl">{t("dash.offsite")}</h2>
      </div>
      {data && data.length === 0 && <p className="text-sm text-neutral-500 card-lux p-6" data-testid="offsite-attempts-empty">{t("dash.offsiteNone")}</p>}
      <div className="space-y-3" data-testid="offsite-attempts-list">
        {(data || []).map((a, i) => {
          const Icon = a.kind === "in" ? LogIn : LogOut;
          return (
            <div key={a.id} data-testid={`offsite-attempt-${a.id}`} className="card-lux p-4 rise" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-medium truncate">{a.employee_name}</div>
                  <div className="text-xs text-neutral-500 truncate">{a.event_name}</div>
                </div>
                <span className="mono text-sm text-red-500 shrink-0" data-testid={`offsite-attempt-distance-${a.id}`}>{fmtDist(a.distance_m, lang)}</span>
              </div>
              <div className="mt-3 flex items-center justify-between text-[11px] text-neutral-500">
                <span className="flex items-center gap-1.5"><Icon className="w-3.5 h-3.5 text-[#C5A059]" />{t(`dash.attempt.${a.kind}`)}{a.tries > 1 && <span className="mono" data-testid={`offsite-attempt-tries-${a.id}`}>×{a.tries}</span>}</span>
                <span className="mono" data-testid={`offsite-attempt-time-${a.id}`}>{fmtDateTimeMtl(a.at)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
